import * as React from 'react';
import styled from 'styled-components';
import {
  IconSystemV2ArrowChevronRightArrowRight,
} from '@doltech/icons/SystemV2/IconSystemV2ArrowChevronRightArrowRight';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { horizontalSpace } from '@doltech/utils/lib/css-style';

const Container = styled.nav`
  display: flex;
  align-items: center;
  ${horizontalSpace(4)}
`;

const BreadCrumbItem = styled.a`
  color: ${colorsV2.purple100};
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid ${colorsV2.purple80};
    color: ${colorsV2.purple100};
  }
`;

interface BreadcrumbItem {
  label: string;
  url: string;
}

interface BreadcrumbGroupGrammarProps {
  breadcrumbLv1?: BreadcrumbItem;
  breadcrumbLv2?: BreadcrumbItem;
  breadcrumbLv3?: BreadcrumbItem;
}

export const BreadcrumbGroupGrammar = (props: BreadcrumbGroupGrammarProps) => {
  const { breadcrumbLv1, breadcrumbLv2, breadcrumbLv3 } = props;
  return (
    <Container>
      <BreadCrumbItem rel="noreferrer" href={breadcrumbLv1?.url}>
        {breadcrumbLv1?.label}
      </BreadCrumbItem>
      <IconSystemV2ArrowChevronRightArrowRight size={16} color="purple100"/>
      <BreadCrumbItem rel="noreferrer" href={breadcrumbLv2?.url}>
        {breadcrumbLv2?.label}
      </BreadCrumbItem>
      <IconSystemV2ArrowChevronRightArrowRight size={16} color="purple100"/>
      <BreadCrumbItem rel="noreferrer" href={breadcrumbLv3?.url}>
        {breadcrumbLv3?.label}
      </BreadCrumbItem>
    </Container>
  );
};
